exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Define the proper variables ans redefine Boostrap ones */\n.modal-full-size.modal-dialog {\n  max-width: 100%;\n  margin: 0;\n  background-color: #343a40; }\n", ""]);

